import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=2e0adcb0&scoped=true&"
import script from "./PayResult.vue?vue&type=script&lang=ts&"
export * from "./PayResult.vue?vue&type=script&lang=ts&"
import style0 from "./PayResult.vue?vue&type=style&index=0&id=2e0adcb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0adcb0",
  null
  
)

export default component.exports